export const PAGINATION_DEFAULT_ITEMS_NOUN = 'Record';
export const PAGINATION_ARIA_LABEL = 'Pagination Navigation';
export const PAGINATION_LABEL_NEXT = 'Next';
export const PAGINATION_LABEL_PREVIOUS = 'Back';
